<script setup>
import { ref, defineProps, defineEmits } from "vue";
import Dialog from "primevue/dialog";
import InputText from "primevue/inputtext";
import Button from "primevue/button";
import { useTerritoriosStore } from "@/store/territorios";
import { useStorage } from "@/composables/useStorage";
import { useAppToast } from "@/composables/useAppToast";

defineProps({
  visible: Boolean,
});
const emit = defineEmits(["update:visible"]);

const territorios = useTerritoriosStore();
const { saveConfig } = useStorage();
const toast = useAppToast();

const saving = ref(false);
const saved = ref(false);

const save = async () => {
  saving.value = true;
  try {
    await saveConfig(["congregacion"]);
  } catch (e) {
    console.error(e);
    toast.error("Ocurrió un error", "No se pudieron guardar los cambios.");
    saving.value = false;
    return;
  }
  saving.value = false;
  saved.value = true;
  setTimeout(() => (saved.value = false), 2500);
};
</script>

<template>
  <Dialog
    :visible="visible"
    @update:visible="(v) => emit('update:visible', v)"
    modal
    header="Congregación"
    :style="{ width: '420px' }"
  >
    <div class="text-sm text-500 mb-3">Nombre visible en el encabezado de salidas</div>
    <InputText
      v-model="territorios.congregacion"
      placeholder="Nombre de la congregación"
      data-e2e="input-congregacion"
      class="w-full"
    />
    <template #footer>
      <Button label="Cerrar" text @click="emit('update:visible', false)" />
      <Button
        :label="saved ? 'Guardado' : 'Guardar'"
        :icon="saved ? 'pi pi-check' : 'pi pi-save'"
        :loading="saving"
        @click="save"
      />
    </template>
  </Dialog>
</template>
